export const endpoint_getAccountingExportOptions = 'getAccountingExportOptions';
export const endpoint_getAccountingExportTransactions = 'getAccountingExportTransactions';
export const endpoint_getAttachments = 'getAttachments';
export const endpoint_getCases = 'getCases';
export const endpoint_getListing = 'getListing';
export const endpoint_getListings = 'getListings';
export const endpoint_getLOIs = 'getLOIs';
export const endpoint_getPortalNotifications = 'getPortalNotifications';
export const endpoint_getReport = 'getReport';
export const endpoint_getReservation = 'getReservation';
export const endpoint_getReservations = 'getReservations';
/** DEV-2521: GET /api/owner/reservation/availability (maintenance block windows). */
export const endpoint_getReservationAvailability = 'getReservationAvailability';
export const endpoint_getStatements = 'getStatements';
export const endpoint_getTasks = 'getTasks';

export const endpoint_patchLMI = 'patchLMI';
export const endpoint_postCaseComment = 'postCaseComment';
export const endpoint_postReservation = 'postReservation';
export const endpoint_putReservationCancel = 'putReservationCancel';
export const endpoint_putReservationUpdate = 'putReservationUpdate';

export const endpoint_patchReservationPaymentMethod = 'patchReservationPaymentMethod';

// Timeshare endpoints
export const endpoint_getTimeshares = 'getTimeshares';
export const endpoint_getTimeshare = 'getTimeshare';
export const endpoint_getTimeshareComps = 'getTimeshareComps';
export const endpoint_getTimesharePrice = 'getTimesharePrice';
export const endpoint_getTimeshareRegions = 'getTimeshareRegions';
export const endpoint_getTimeshareResort = 'getTimeshareResort';
export const endpoint_getTimeshareResorts = 'getTimeshareResorts';
export const endpoint_getTimeshareBuildings = 'getTimeshareBuildings';
export const endpoint_getTimeshareViews = 'getTimeshareViews';
export const endpoint_getTimeshareBedrooms = 'getTimeshareBedrooms';
export const endpoint_getTimeshareUnitTypes = 'getTimeshareUnitTypes';
export const endpoint_getTimeshareListing = 'getTimeshareListing';
export const endpoint_getTimeshareListings = 'getTimeshareListings';
export const endpoint_patchTimeshareRentalAmount = 'patchTimeshareRentalAmount';
export const endpoint_patchTimeshareStatus = 'patchTimeshareStatus';
export const endpoint_patchTimesharePricingStrategy = 'patchTimesharePricingStrategy';
export const endpoint_patchTimeshareAcceptRecommendedRate = 'patchTimeshareAcceptRecommendedRate';
export const endpoint_postTimeshareRenew = 'postTimeshareRenew';
export const endpoint_postTimeshareCreate = 'postTimeshareCreate';
export const endpoint_postTimeshareCommissionAgreement = 'postTimeshareCommissionAgreement';
export const endpoint_getTimeshareSingleListing = 'getTimeshareSingleListing';
export const endpoint_getRelatedAccounts = 'getRelatedAccounts';
export const endpoint_getOwnerProfile = 'getOwnerProfile';
